import * as PIXI from "pixi";
import Cs from "../utils/Cs";
import { PixelHelper } from "../utils/PixelHelper";

import { Random } from "../utils/Random";
import { CROUTE_LIMIT } from "./conf";
import Loader from "../Loader";

// TODO: improve this code
// Very very similar to flash version, but not pixel perfect !
// Patform : Drawings are more "smooths" in Flash, sometimes larger.
// Line : Some irregularities not replicated

export function getPlatform(
  renderer: PIXI.Renderer,
  w: number,
  rid: number,
  rot: number,
  did: number,
  flGrass: boolean
): PIXI.DisplayObject {
  let rnd = new Random(rid);

  const container = new PIXI.Container();

  // MASK
  let mcMask = new PIXI.Container();

  let max = 2 + w * 0.2;
  let sc = Math.min(w * 0.1, 80);
  for (let i = 0; i < max; i++) {
    let mc = new Loader.movieclips.mcForm();
    mcMask.addChild(mc);
    mc.angle = rnd.rand() * 360;
    mc.x = rnd.rand() * w;
    let c = 1 - Math.abs((mc.x - w * 0.5) / (w * 0.5));
    mc.y = (rnd.rand() * 2 - 1 - 0.6) * (w * 0.1) * c;
    mc.scale.set((15 + c * sc) / 100);

    mc.gotoAndStop(did);
    mc.get("sub").gotoAndStop(rnd.random(mc.get("sub").totalFrames));
  }

  mcMask.angle = rot;

  let b = mcMask.getBounds();
  mcMask.x = -b.x;
  mcMask.y = -b.y;

  const mcCont = new PIXI.Container();
  mcCont.addChild(mcMask);
  container.addChild(mcCont);

  // TEXTURE
  // TODO
  let text = Loader.textures[`text${did + 1}`];
  let sprite = new PIXI.TilingSprite(text, b.width, b.height);
  container.addChild(sprite);

  // TODO: ELEMENT SUP

  if (flGrass) {
    const croute = encroute(renderer, mcCont, did);
    container.addChild(croute);
  }

  sprite.mask = mcCont;
  return container;
}

export function getLine(
  renderer: PIXI.Renderer,
  w: number,
  lst: number[][],
  did: number,
  flCroute: boolean
): PIXI.DisplayObject {
  const container = new PIXI.Container();

  let mcMask = new PIXI.Container();
  let list = [...lst];
  list.unshift([0, 0]);

  let lp: { x: number; y: number } | null = null;

  for (let i = 0; i < list.length; i++) {
    let p = list[i];

    let mc = new PIXI.Graphics();
    mc.beginFill(0xff0000).drawCircle(0, 0, 50).endFill();
    mc.x = p[0];
    mc.y = p[1];
    mc.scale.x = w / 100;
    mc.scale.y = w / 100;

    mcMask.addChild(mc);

    if (lp != null) {
      mc.x += lp.x;

      mc.y += lp.y;
    }
    let np = { x: mc.x, y: mc.y };

    if (lp != null) {
      let line = new PIXI.Graphics();
      line.beginFill(0xff0000).drawRect(0, -50, 100, 100).endFill();
      line.x = mc.x;
      line.y = mc.y;
      line.scale.x = Cs.getDist(lp, np) / 100;
      line.scale.y = w / 100;

      // line.rotation = Cs.getAng(lp, np) / 0.0174;
      line.rotation = Cs.getAng(lp, np);

      mcMask.addChild(line);
    }

    lp = np;
  }

  //
  const b = mcMask.getBounds();
  mcMask.x = -b.x;
  mcMask.y = -b.y;

  const mcCont = new PIXI.Container();
  mcCont.addChild(mcMask);
  container.addChild(mcCont);

  let text = Loader.textures[`text${did + 1}`];
  let sprite = new PIXI.TilingSprite(text, b.width, b.height);
  container.addChild(sprite);

  if (flCroute) {
    const croute = encroute(renderer, mcCont, did);
    container.addChild(croute);
  }

  sprite.mask = mcCont;
  return container;
}

/**
 * Generate a platform "croute"
 * @param renderer PIXI renderer to manipulate pixels
 * @param mask Platform shape
 * @param did Level theme
 * @returns The croute display object
 */
function encroute(
  renderer: PIXI.Renderer,
  mask: PIXI.DisplayObject,
  did: number
): PIXI.DisplayObject {
  let container = new PIXI.Container();

  // CROUTE
  const ph = new PixelHelper(renderer, mask);
  // ph.debugImage();

  const crouteText = Loader.textures[`mcCroute${did + 1}`].baseTexture;
  const crouteTextRect = new PIXI.Rectangle(
    0,
    0,
    crouteText.width,
    crouteText.height
  );

  let cx = 0;
  let sy = 0;
  let pile: number[] = [];
  for (let x = 0; x < ph.width; x++) {
    let flLast = x == ph.width - 1;
    let ry: number | null = null;

    for (let y = sy; y < ph.height; y += 1) {
      if (ph.hitTest(new PIXI.Point(x, y))) {
        ry = y;
        break;
      }
    }
    if (ry != null) ry--; // FIXME ?
    let py: number | null = pile[pile.length - 1];
    if (
      ry != null &&
      (pile.length == 0 || Math.abs(py - ry) < CROUTE_LIMIT) &&
      !flLast
    ) {
      let dy = ry;
      if (pile.length > 0) dy = ry * 0.5 + py * 0.5;
      pile.push(dy);
      sy = Math.floor(dy - CROUTE_LIMIT);
    } else {
      if (pile.length > 5) {
        let dx = x;
        let cMax = 0.1;
        while (pile.length > 0) {
          cMax = Math.min(1, cMax + 0.2);
          let cBot = pile.length * 0.1;
          let c = Math.min(cMax, cBot);
          dx--;
          let dy = pile.pop();
          let r = new PIXI.Rectangle(cx, 0, 1, crouteTextRect.height * c);
          let dest = new PIXI.Point(dx, dy);

          const pixelColumnRect = new PIXI.Rectangle(
            crouteTextRect.x + r.x,
            crouteTextRect.y + r.y,
            r.width,
            r.height
          );
          const pixelColumnText = new PIXI.Texture(crouteText, pixelColumnRect);
          const pixelColumnSprite = new PIXI.Sprite(pixelColumnText);
          pixelColumnSprite.x = dest.x;
          pixelColumnSprite.y = dest.y;
          container.addChild(pixelColumnSprite);

          // TODO: This is a lot of sprites (1 per pixel). We should find a way to optimise that !

          cx = (cx + 1) % crouteTextRect.width;
        }
      }
      pile = [];
      py = null;
      sy = 0;
    }
  }

  return container;
}
